import React, { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import Button from "../Button/Button";
import { menuPaperSx, menuItemSx } from "../internal/menuSx";

/**
 * Select-style dropdown (e.g. the sort control). Brand secondary-button trigger
 * + shared brand menu.
 *
 * Props:
 *   value, options [{ value, label }], onChange
 *   label:  optional prefix shown muted before the value (e.g. "Sort:")
 *   size:   "sm" | "md" | "lg"  (default "md")
 */
const Caret = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const Dropdown = ({ value, options = [], onChange, label, size = "md", className = "" }) => {
  const [anchor, setAnchor] = useState(null);
  const current = options.find((o) => o.value === value);

  return (
    <>
      <Button
        variant="secondary"
        size={size}
        endIcon={<Caret />}
        className={className}
        onClick={(e) => setAnchor(e.currentTarget)}
        aria-haspopup="menu"
      >
        {label && <span style={{ color: "var(--on-surface-muted, #64748b)", marginRight: 4 }}>{label}</span>}
        {current ? current.label : "Select"}
      </Button>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        slotProps={{ paper: { sx: menuPaperSx } }}
      >
        {options.map((o) => (
          <MenuItem
            key={o.value}
            selected={o.value === value}
            onClick={() => {
              if (onChange) onChange(o.value);
              setAnchor(null);
            }}
            sx={menuItemSx}
          >
            {o.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default Dropdown;
